import { MutationTree } from "vuex";
import { Device, DeviceMutations, DeviceState, DeviceByDay } from "./interface";
import { DeviceMutationsTypes } from "./types";

export const mutations: MutationTree<DeviceState> & DeviceMutations = {
  [DeviceMutationsTypes.SET_DEVICE](state: DeviceState, payload: Array<Device>): void {
    state.DeviceById = {};
    state.DeviceAllId = [];

    payload.forEach((role) => {
      state.DeviceById[role._id] = role;
      state.DeviceAllId.push(role._id);
    });
  },
  [DeviceMutationsTypes.SET_DEVICE_BY_DAY](state: DeviceState, payload: Array<DeviceByDay>): void {
    state.DeviceByDay = payload;
  },
  [DeviceMutationsTypes.UPDATE_DEVICE](state: DeviceState, payload: Device): void {
    state.DeviceById[payload._id] = payload;
    state.DeviceAllId.splice(state.DeviceAllId.lastIndexOf(payload._id), 1);
    state.DeviceAllId.unshift(payload._id);
  },
  [DeviceMutationsTypes.GET_DEVICE](state: DeviceState, payload: Device): void {
    if (state.DeviceById[payload._id] === undefined) {
      state.DeviceAllId.push(payload._id);
    } else {
      state.DeviceAllId.splice(state.DeviceAllId.lastIndexOf(payload._id), 1);
      state.DeviceAllId.unshift(payload._id);
    }
    state.DeviceById[payload._id] = payload;
  },
  [DeviceMutationsTypes.CREATE_DEVICE](state: DeviceState, payload: Device): void {
    state.DeviceById[payload._id] = payload;
    state.DeviceAllId.unshift(payload._id);
  },
  [DeviceMutationsTypes.UPDATE_MULTIPLE_DEVICE](state: DeviceState, payload: Array<Device>): void {
    payload.forEach((device) => {
      state.DeviceById[device._id] = device;
      state.DeviceAllId.splice(state.DeviceAllId.lastIndexOf(device._id), 1);
      state.DeviceAllId.unshift(device._id);
    });
  },
  [DeviceMutationsTypes.SET_MULTIPLE_DEVICE](state: DeviceState, payload: Array<Device>): void {
    payload.forEach((role) => {
      state.DeviceById[role._id] = role;
      state.DeviceAllId.unshift(role._id);
    });
  },
  [DeviceMutationsTypes.REMOVE_DEVICE](state, deviceName: string) {
    const deviceId = state.DeviceAllId.find((id) => state.DeviceById[id].material_name === deviceName);
    if (deviceId === undefined) return;
    delete state.DeviceById[deviceId];
    state.DeviceAllId = state.DeviceAllId.filter((id) => id !== deviceId);
  }
};
